import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getStageName, i18nIntl, isNotEmpty } from '../lib/ep';
import { useCSS } from '../lib/hooks';

import ActionLink from '../components/builder/ActionLink';
import WinnerLayer from '../components/prizes/WinnerLayer';
import { formatTokenTitle } from '../components/front/loyalty/TokenAmount';
import TokenIcon from '../components/front/loyalty/TokenIcon';
import TokensWallet from '../components/front/loyalty/TokensWallet';
import PrizeGalleryButton from '../components/front/buttons/PrizeGalleryButton';
import ButtonCollection from '../components/builder/ButtonCollection';

const SingleTransaction = ({ item, ...props }) => {
	if(!isNotEmpty(item, 'type') || !isNotEmpty(item, 'target')) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const promotion = props?.promotion?.Promotion ?? false;
	const is_multistage = promotion?.is_multistage ?? false;

	const token = props.tokens[item.token_id].LoyaltyToken;
	
	const data = JSON.parse((isNotEmpty(item, 'data')) ? item.data : '{}');
	data.num = parseInt(item.amount);
	data.coin_name = formatTokenTitle(token, data.num);

	let image = false;
	let message = "";
	switch(item.type) {
		case '1':
			// on token receive after participate:
			// target : stage_id
			data.stage_name = getStageName({ display_title:data?.stage_name, id:item.target }, i18n);

			if(isNotEmpty(token, 'full_image')) {
				image = <TokenIcon token={token} />;
			} else {
				image = <TokenIcon icon='knk-plus' />;
			}

			message = (is_multistage) ? "You've earned {num} {coin_name} by participating in: {stage_name}." : "You've earned {num} {coin_name}.";
			break;

		case '2':
			// on prize redeem:
			// target : prize_type_id
			data.prize_name = <ActionLink
				onClick={() => props.openWinnerLayer(item.target)}
			>{props.prizes[item.target]}</ActionLink>;

			data.num = Math.abs(data.num);

			image = <TokenIcon icon='knk-present-fill' />;

			message = "You've spent {num} {coin_name} to redeem the prize: {prize_name}.";
			break;

		case '3':
			// on manual modification (from Audience):
			// target : agent_id
			image = <TokenIcon icon='knk-me' />;

			if(data.num < 0) {
				message = "You've spent {num} {coin_name}{reason}.";
			} else {
				message = "You've earned {num} {coin_name}{reason}.";
			}

			data.num = Math.abs(data.num);
			data.reason = "";	// we use the label containing "{reason}" but only to avoid createing a new label almost exact
			break;

		case '4':
			// coin prize:
			// target : prize_type_id
			data.prize_name = <ActionLink
				onClick={() => props.openWinnerLayer(item.target)}
			>{props.prizes[item.target]}</ActionLink>;

			if(isNotEmpty(token, 'full_image')) {
				image = <TokenIcon token={token} />;
			} else {
				image = <TokenIcon icon='knk-plus' />;
			}

			message = "You've earned {num} {coin_name} after winning the prize: {prize_name}.";
			break;

		case '5':
			// requirement coin stage:
			// target : stage_id
			data.stage_name = getStageName({ display_title:data?.stage_name, id:item.target }, i18n);

			data.num = Math.abs(data.num);

			image = <TokenIcon icon='knk-recommendator' />;

			message = (is_multistage) ? "You've spent {num} {coin_name} by participating in: {stage_name}." : "You've spent {num} {coin_name}.";
			break;

		case '6':
			// via API:
			image = <TokenIcon icon='knk-me' />;

			data.reason = isNotEmpty(token, 'reason') ? `: ${token.reason}` : "";

			if(data.num < 0) {
				message = "You've spent {num} {coin_name}{reason}.";
			} else {
				message = "You've earned {num} {coin_name}{reason}.";
			}

			data.num = Math.abs(data.num);

			break;
		}

	return (
		<li class="transaction_item">
			<div>
				{(image !== false) && (
					image
				)}

				<div class="data">
					<FormattedMessage
						id={message}
						values={data}
					/>

					<span class="date">{EPGetTimezone(item.created, promotion.timezone, 'L, HH:mm')}</span>
				</div>
			</div>
		</li>
	)
};

const Wrapper = (props) => {
	const promotion = props?.promotion?.Promotion ?? false;

	return (
		<div class="my_rewards">
			<TokensWallet
				tokens={props.loyalty.tokens}
				totals={props.loyalty.totals}
				intl={props.intl}
			/>

			<ButtonCollection _class={{ other:'gui_flex_col' }} style={{ gap:'0.5em' }}>
				<PrizeGalleryButton
					promotion={promotion}
					icon={false}
				/>

				<ActionLink
					onClick={() => history.go(-1)}
				>Go back</ActionLink>
			</ButtonCollection>

			{props.children}
		</div>
	)
};

const UserRewards = (props) => {
	useCSS('comp/prize_gallery.css');
	useCSS('comp/my_prizes.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const loyalty = props?.loyalty ?? {};
	const prizes = props?.prizes ?? [];
	const promotion = props?.promotion ?? false;

	if(promotion === false) return null;

	const transactions = Object.values(loyalty?.transactions ?? {})[0];
	const total_transactions = transactions.length;

	const [ current, setCurrent ] = useState(0);
	const [ display_prize_layer, setDisplayPrizeLayer ] = useState(false);

	const indexed_prizes = {};
	for(let i in prizes) {
		indexed_prizes[prizes[i].PrizeType.id] = prizes[i].PrizeType.title;
	}

	const openWinnerLayer = (prize_id) => {
		let selected_prize = 0;
		for(let i in prizes) {
			if(prizes[i].PrizeType.id == prize_id) {
				selected_prize = i;
				break;
			}
		}

		setCurrent(selected_prize);
		setDisplayPrizeLayer(true);
	};

	if(total_transactions == 0) {
		return (
			<Wrapper
				loyalty={loyalty}
				promotion={promotion}
				intl={props.intl}
			>
				<p class="gui_not_in_top_huge">{i18n("You have no transactions right now.")}</p>
			</Wrapper>
		);
	}

	return (
		<Wrapper
			loyalty={loyalty}
			promotion={promotion}
			intl={props.intl}
		>
			<ul class="won_prizes_textual_list">
				<li class="titles">
					<strong>{i18n("History")}</strong>
				</li>

				{transactions.map((item) => {
					return (
						<SingleTransaction
							key={`transactions_${item.LoyaltyLogin.id}`}
							item={item.LoyaltyLogin}
							tokens={loyalty.tokens}
							promotion={promotion}
							openWinnerLayer={openWinnerLayer}
							prizes={indexed_prizes}
							intl={props.intl}
						/>
					)
				})}
			</ul>

			{(display_prize_layer) && (
				<WinnerLayer
					prize={prizes[current].PrizeType}
					user_prize={prizes[current].Prize}
					user={prizes[current].User}
					share={prizes[current].Share}
					code={prizes[current].PromoCode}
					code_validation={prizes[current]?.CodeValidation ?? null}
					autoplay={true}
					backButton={() => setDisplayPrizeLayer(false)}>
				</WinnerLayer>
			)}
		</Wrapper>
	)
};

export default injectIntl(UserRewards);